import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { C } from "../theme/colors";
import Section from "../components/Section";

const EVENTS_API_URL = "https://ccapi.rapifuzz.in:8443/api/events/";

function formatEventDate(dateStr) {
  if (!dateStr) return "";
  const d = new Date(dateStr);
  if (isNaN(d)) return dateStr;
  return d.toLocaleDateString("en-US", { month: "short", year: "numeric" });
}

export default function EventDetailPage() {
  const { eventId } = useParams();
  const navigate = useNavigate();
  const [event, setEvent]     = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError]     = useState(null);

  useEffect(() => {
    if (!eventId) return;
    let cancelled = false;
    setLoading(true);
    setError(null);

    fetch(`${EVENTS_API_URL}${eventId}/`)
      .then(res => {
        if (!res.ok) throw new Error(`Request failed (${res.status})`);
        return res.json();
      })
      .then(data => { if (!cancelled) setEvent(data); })
      .catch(err => { if (!cancelled) setError(err.message); })
      .finally(() => { if (!cancelled) setLoading(false); });

    return () => { cancelled = true; };
  }, [eventId]);

  return (
    <div className="page-fade">
      <div style={{background:C.navyDark,padding:"140px 40px 50px"}}>
        <div style={{maxWidth:900,margin:"0 auto"}}>
          <button
            onClick={() => navigate("/events")}
            style={{background:"none",border:"none",cursor:"pointer",color:"rgba(255,255,255,0.7)",fontSize:13.5,display:"flex",alignItems:"center",gap:6,marginBottom:20,padding:0}}
          >
            ← Back to Events
          </button>

          {loading && (
            <p style={{color:"rgba(255,255,255,0.7)"}}>Loading event…</p>
          )}

          {!loading && error && (
            <p style={{color:"rgba(255,255,255,0.7)"}}>Couldn't load this event. It may have been removed.</p>
          )}

          {!loading && !error && event && (
            <>
              <div style={{display:"flex",alignItems:"center",gap:12,marginBottom:16}}>
                {event.tags_name && (
                  <span className="tag">{event.tags_name}</span>
                )}
                {event.publish_date && (
                  <span style={{display:"flex",alignItems:"center",gap:5,fontSize:13.5,color:"rgba(255,255,255,0.65)"}}>
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="3" y="4" width="18" height="18" rx="2"/><path d="M16 2v4M8 2v4M3 10h18"/></svg>
                    {formatEventDate(event.publish_date)}
                  </span>
                )}
              </div>
              <h1 style={{fontWeight:700,fontSize:"clamp(1.6rem,3.2vw,2.4rem)",color:C.white,lineHeight:1.25,marginBottom:0}}>
                {event.title}
              </h1>
            </>
          )}
        </div>
      </div>

      {!loading && !error && event && (
        <Section>
          <div style={{maxWidth:800,margin:"0 auto"}}>
            <div
              className="body"
              style={{fontSize:15.5,lineHeight:1.9}}
              dangerouslySetInnerHTML={{__html: event.description}}
            />

            {event.registration_link && (
              <a
                href={event.registration_link}
                target="_blank"
                rel="noopener noreferrer"
                className="btn-primary"
                style={{display:"inline-block",marginTop:30,textDecoration:"none"}}
              >
                Register →
              </a>
            )}
          </div>
        </Section>
      )}
    </div>
  );
}